import omnia from "@localization/omnia.json";
import { initializeTextContent } from "@deloitte-omnia/core-fe-mfe/TextContent";

export const init_locale = () => {
  initializeTextContent({
    language: "en-US",
    namespaces: ["omnia", "localization"],
    options: {
      fallbackNS: "omnia",
      keySeparator: false,
      debug: true,
      react: {
        useSuspense: false,
        wait: true,
      },
      resources: {
        "en-US": {
          omnia,
        },
      },
    },
  });
};
